<form *ngIf="mainForm.controls.ApplicantItems" [formGroup]="mainForm">
    <div class="row">

        <div class="col-lg-12">
          <div class="card card-primary">
            <div class="card-header text-uppercase"> {{title}} </div>
            <div class="card-body">


    <!-- <label>Notes: </label>
    <input formControlName="Caption" /><br> -->


  <div formArrayName="ApplicantItems">
    <div *ngFor="let appItem of getApplicantItemsArray(mainForm); let i=index; let last = last">
      <div formGroupName="{{i}}">




      <div class="tile">
          <div class="tile-title-w-btn text-primary">
            <h6 class="title text-uppercase">{{i+1}}. HIGHER EDUCATIONAL</h6>
            <div class="btn-group">
              <button *ngIf="last" class="btn btn-primary"
               (click)="onAddItemClick()"><i class="fa fa-lg fa-plus"></i>Add
                New</button>
              <button class="btn btn-primary" [disabled]="!appItem.valid" (click)="onSaveItemClick(appItem,i)"><i class="fa fa-lg fa-save"></i>Save</button>
              <button class="btn btn-primary"  (click)="onRemoveItemClick(i)"><i
                  class="fa fa-lg fa-trash"></i>Remove</button>
            </div>
          </div>
          <div class="tile-body">
            <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label> Name of Institution <small class="text-muted">(required)</small> </label>
                    <input type="text" formControlName="NameOfInstitution"  class="form-control">

                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label>
                        Programme Offered <small class="text-muted">(required)</small>
                    </label>
                    <input type="text" formControlName="ProgrammeOffered"  class="form-control">

                  </div>
                </div>
              </div>




              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label> Ceritificate Obtain <small class="text-muted">(required)</small> </label>
                    <input type="text" formControlName="CeritificateObtain"  class="form-control">

                  </div>
                </div>


            <div class="col-md-6">
                <div class="form-group">

                  <div class="inline-dev">
                      <div class="months">
                          <label> Month of Entry <small class="text-muted">(required)</small> </label>
                  <select formControlName="MonthOfEntry" class="form-control">
                    <option value="">SELECT MONTH of ENTRY</option>
                    <option *ngFor="let yes of months" value="{{yes.Id}}">
                      {{yes.Name}}
                    </option>

                  </select>
                      </div>
                      <div class="years">
                          <label>Year of Entry <small class="text-muted">(required)</small></label>

                          <select formControlName="YearOfEntry" class="form-control">
                              <option value="">SELECT YEAR of ENTRY</option>
                              <option *ngFor="let yes of years" value="{{yes.Name}}">
                                {{yes.Name}}
                              </option>

                            </select>
                      </div>



                  </div>




                </div>
              </div>
            </div>



            <div class="row">
              <div class="col-md-6">
                <div class="form-group">

                    <div class="inline-dev">
                        <div class="months">
                            <label> Month of Completion <small class="text-muted">(required)</small> </label>
                    <select formControlName="MonthOfCompletion" class="form-control">
                      <option value="">SELECT Month of Completion</option>
                      <option *ngFor="let yes of months" value="{{yes.Id}}">
                        {{yes.Name}}
                      </option>

                    </select>
                        </div>
                        <div class="years">
                            <label>Year of Completion <small class="text-muted">(required)</small></label>

                            <select formControlName="YearOfCompletion" class="form-control">
                                <option value="">SELECT Year of Completion</option>
                                <option *ngFor="let yes of years" value="{{yes.Name}}">
                                  {{yes.Name}}
                                </option>

                              </select>
                        </div>



                    </div>

                </div>
              </div>

                <div class="col-md-6">

                </div>
              </div>


          </div>
        </div>

      </div>
    </div>

    <div class="form-group">
        <button type="button" (click)="onAddItemClick()"
         class="btn btn-primary btn-block waves-effect waves-light m-1">
          <i class="icon-magnifier-add"></i> Add New Higher Institution Attended
        </button>
      </div>


  </div>




  </div>


  <div class="form-footer">
    <div class="form-group text-center">
      <button class="btn btn-default waves-effect waves-light m-1" (click)="goToPrevious(mainForm)"><i
          class="fa fa-backward"></i> Go Back</button>

      <button class="btn btn-primary waves-effect waves-light m-1" id="next" [disabled]="!isFormValid()"
        (click)="goToNext(mainForm)">Save &amp; Continue</button>
    </div>
  </div>
  </div>
  </div>

  </div>

  </form>


  <!-- <pre>{{ mainForm.value | json }}</pre> -->
